module.exports = __webpack_public_path__ + "static/media/learning-center.2a6181e2.svg";